var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Group } from '@/models/Group';
import SkillSetSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/SkillSetSelector/SkillSetSelector.vue';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import client from '@/support/Client';
let AddSkillSetDialog = class AddSkillSetDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedStudents = {};
        this.selectedSkillSet = null;
        this.currentStep = 1;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select students'), value: 1 },
                { label: this.$tc('Select skill set'), value: 2 },
            ],
            title: this.$tc('Add skill set'),
            customButtons: [
                {
                    label: this.$tc('actions.add'),
                    action: () => {
                        this.create();
                    },
                    visible: this.currentStep === 2,
                    disabled: this.isDisabled,
                }
            ]
        };
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onClose() {
        this.$emit('close');
    }
    onSelectedStudents(value) {
        this.$set(this, 'selectedStudents', value);
    }
    onSelectedSkillSet(value) {
        this.$set(this, 'selectedSkillSet', value);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
    }
    onReset() {
        this.selectedStudents = {};
        this.selectedSkillSet = null;
        this.currentStep = 1;
    }
    // #endregion
    // #region Async methods (api calls only)
    async create() {
        if (!Object.keys(this.selectedStudents).length || !this.selectedSkillSet || !this.selectedSkillSet.id) {
            return;
        }
        let users = [];
        Object.keys(this.selectedStudents).forEach(selectedStudent => {
            users = [...[selectedStudent], ...users];
        });
        const payload = {
            category: this.selectedSkillSet.id,
            users,
        };
        try {
            await client('post', 'portfolios/skills/to-group-from-category', payload);
            this.onReset();
            this.$emit('submitted');
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return Object.keys(this.selectedStudents).every((key) => {
                    return this.selectedStudents[key] === false;
                }) || Object.keys(this.selectedStudents).length === 0;
            case 2:
                return !this.selectedSkillSet || !this.selectedSkillSet.id;
            default:
                return false;
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], AddSkillSetDialog.prototype, "group", void 0);
AddSkillSetDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            SkillSetSelector,
            StudentSelector,
            LabelValue,
        }
    })
], AddSkillSetDialog);
export default AddSkillSetDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
